<template>
	<v-container class="deploy-in-progress-container d-flex flex-column justify-center align-center">
		<div class="deploy-in-progress-content">
			<v-row class="pb-8" align="center" justify="center">
				<v-img contain max-width="250" src="@/assets/img/logo-adamo.svg"></v-img>
			</v-row>

			<v-row>
				<v-col>
					<h2 class="text-center mb-4">{{ $t("deployInProgress.title") }}</h2>
					<p class="text-center" v-html="$t('deployInProgress.summary')"></p>
				</v-col>
			</v-row>
		</div>
	</v-container>
</template>
<script lang="ts">
import Vue from "vue";

export default Vue.extend({
	name: "DeployInProgressView"
});
</script>
<style scoped lang="scss">
@import "~vuetify/src/styles/settings/_variables";
.deploy-in-progress-container {
	height: 100%;
	width: 70%;
}
.deploy-in-progress-content {
	width: 550px;
}

@media #{map-get($display-breakpoints, 'lg-and-down')} {
	.deploy-in-progress-content {
		width: 550px;
	}
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
	.deploy-in-progress-content {
		width: 450px;
	}
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
	.deploy-in-progress-content {
		width: 350px;
	}
}
</style>
